










































import _ from 'lodash';
import { Loader } from 'mycorems-app-shared';
import {
  SubscribeBtn,
  offSubscribedToAccount,
  offUnsubscribedFromAccount,
  onSubscribedToAccount,
  onUnsubscribedFromAccount,
} from 'mycorems-app-accounts';
import { EmailReportGenerated, PricePlanStarted, ClientEdited } from '@/messaging/events';
import { AccountSubscriber, Client } from '@/types';
import { UserContextMixin } from '@/mixins';
import eventBus from '@/messaging/event-bus';
import ClientItem from '../account/client/ClientItem.vue';
import clientRepository from '../account/client/client-repository';

interface Data {
  task: Promise<Client[]>|null,
  clients: Client[],
  searchQuery: string|null,
  clientTask: Promise<Client>|null,
  maxItems: number,
}

export default UserContextMixin.extend({
  props: {
    searchable: {
      type: Boolean,
      default: false,
    },
  },
  data(): Data {
    return {
      task: null,
      clients: [],
      searchQuery: null,
      clientTask: null,
      maxItems: 4,
    };
  },
  watch: {
    userId: {
      handler() {
        this.load();
      },
      immediate: true,
    },
    searchQuery: {
      handler() {
        this.load();
      },
      immediate: true,
    },
  },
  computed: {
    filteredClients(): Client[] {
      return this.clients.slice(0, this.maxItems);
    },
    viewBtnLabel(): string {
      return (this.clients.length > this.maxItems)
        ? `Show All (${this.clients.length - this.maxItems})` : 'Show Less';
    },
  },
  methods: {
    viewToggle(): void {
      if (this.clients.length > this.maxItems) {
        this.maxItems = this.clients.length;
      } else {
        this.maxItems = 4;
      }
    },
    add(accountSubscriber: AccountSubscriber): void {
      this.clients.unshift(accountSubscriber.account);
    },
    remove(clientId: string): void {
      const index = this.clients.findIndex(c => c.id === clientId);
      if (index >= 0) {
        this.clients.splice(index, 1);
      }
    },
    getClient(id: string): Promise<Client> {
      return clientRepository.find(id);
    },
    onSubscribe(event): void {
      const { accountSubscriber } = event;
      if (accountSubscriber.user.id === this.userId) {
        this.remove(accountSubscriber.account.id);
      }
    },
    onUnsubscribe(event): void {
      const accountSubscriber = _.cloneDeep(event.accountSubscriber);
      if (accountSubscriber.user.id === this.userId) {
        this.clientTask = this.getClient(accountSubscriber.account.id);
        this.clientTask.then((client: Client) => {
          const subscriber = _.set(accountSubscriber, 'account', client);
          this.add(subscriber);
        });
      }
    },
    onClientEdited(event: ClientEdited): void {
      const index = this.clients.findIndex(client => client.id === event.id);
      if (index >= 0) {
        this.clients[index].name = event.name;
      }
    },
    load() {
      this.task = clientRepository.findUnsubscribed(this.userId, this.searchQuery);
      this.task.then((clients: Client[]) => {
        this.clients = clients;
      });
    },
  },
  created(): void {
    eventBus.$on(PricePlanStarted.eventName, this.load);
    eventBus.$on(EmailReportGenerated.eventName, this.load);
    eventBus.$on(ClientEdited.eventName, this.onClientEdited);
    onSubscribedToAccount(this.onSubscribe);
    onUnsubscribedFromAccount(this.onUnsubscribe);
  },
  beforeDestroy(): void {
    eventBus.$off(PricePlanStarted.eventName, this.load);
    eventBus.$off(EmailReportGenerated.eventName, this.load);
    eventBus.$off(ClientEdited.eventName, this.onClientEdited);
    offSubscribedToAccount(this.onSubscribe);
    offUnsubscribedFromAccount(this.onUnsubscribe);
  },
  components: {
    loader: Loader,
    'client-item': ClientItem,
    'subscribe-btn': SubscribeBtn,
  },
});
